import { getCountdownConfig } from "containers/Events/Countdown";
import { dynamicCountdown } from "helpers/dynamicCountdown";

export const useUpcomingInternalEvent = ({ type, startAt, endAt }) => {
  const isInternalEvent = type === 'Event::Internal'
  const countdownValue = dynamicCountdown(startAt, endAt);
  const config = getCountdownConfig(countdownValue);

  return { isInternalEvent, countdownValue, config }
}